module.exports = __webpack_public_path__ + "img/Gilat_Communications.05a64d26.svg";